export const setCookie = (cname, cvalue, exdays, domain)=>{
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    var cookieString = cname + "=" + cvalue + ";" + expires + ";path=/";
    if (domain) {
        const dotted = domain.startsWith('.') ? domain : '.' + domain;
        cookieString += ";domain=" + dotted;
    }
    document.cookie = cookieString;
};
export const getCookie = (cname)=>{
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i < ca.length; i++){
        var c = ca[i];
        while(c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};
export const deleteCookie = (cname, domain)=>setCookie(cname, '', -1, domain);
